import { CapoPlugin } from "/app/node_modules/.pnpm/@unhead+vue@1.9.14_vue@3.5.4_typescript@5.5.3_/node_modules/@unhead/vue/dist/index.mjs";
export default import.meta.server ? [CapoPlugin({ track: true })] : [];